module.exports = __webpack_public_path__ + "media/Even a Hero Falls.1910aa1c.mp3";